import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { StageConfig } from 'collage-designer/stage/stage-config';
import { StageService } from 'collage-designer/stage/stage.service';
import { AsyncEventEmitterSubscriber } from 'core/utils/async-event-emitter';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService, } from '../toolbox.service';

import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'preview-toolbox',
  templateUrl: './preview-toolbox.component.html',
  styleUrls: [ '../toolbox.component.scss', ],
})
export class PreviewToolboxComponent extends ToolboxComponent
    implements OnDestroy
{
  public stageID: string | undefined;
  public previewUrl: string | undefined;

  private subscriptions: Subscription = new Subscription();
  private stageConfigChangedSubscription:
      AsyncEventEmitterSubscriber<StageConfig>;

  constructor(
      private cdr: ChangeDetectorRef,
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(ToolboxService) toolboxService,
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService)
  {
    super(mir, sanitizer, toolboxService);

    this.loadIcon('preview');

    this.subscriptions.add(
        this.stageService.stageConfigApplied.subscribe(() => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        }));
    this.subscriptions.add(
        this.toolboxService.placeholderChanged.subscribe(() => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        }));
    this.stageConfigChangedSubscription =
        this.stageService.stageConfigChanged.subscribe(async (_) => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        });
    this.setPreviewParams();
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
    this.stageService.stageConfigChanged.unsubscribe(
        this.stageConfigChangedSubscription);
  }

  private setPreviewParams(): void
  {
    this.stageID = this.getStageID();
    this.previewUrl = this.getPreviewUrl();
  }

  private getStageID(): string | undefined
  {
    const stageReference = this.stageService.getCurrentStageReference();

    return stageReference ? stageReference.attr('id') : undefined;
  }

  private getPreviewUrl(): string | undefined
  {
    return this.designStepService.getPart().previewUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/preview-toolbox/preview-toolbox.component.ts